import React, { useState, useEffect, useContext } from 'react';
import Container from '@material-ui/core/Container';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import { HighlightOffRounded } from '@material-ui/icons';
import Cookies from 'js-cookie';
import { UserContext } from '../contexts/userContext';

export default function LanguageSelection(props) {
  const { lan, machineID, langs, setlangs, ...rest } = props;
  const { stat, setStat } = useContext(UserContext);

  const [language, setLanguage] = useState('');

  useEffect(() => {
    const currentLan = Cookies.get('i18next') || lan[0].name;
    setLanguage(lan.length > 0 ? currentLan : '');
  }, [lan]);

  useEffect(() => {
    props.onHide();
  }, [language]);

  const onClick = async (e) => {
    // console.log('targetID', e.code);
    if (e.code === 'en') {
      stat.language.en = stat.language.en += 1;
    }
    if (e.code === 'fr') {
      stat.language.fr = stat.language.fr += 1;
    }
    if (e.code === 'es') {
      stat.language.es = stat.language.es += 1;
    }
    setLanguage(e.code);
    setlangs(e.code);
    setStat(stat);
    console.log(stat);

    await i18next.changeLanguage(e.code);
  };

  return (
    <Modal dialogClassName="sl-modal" {...rest} centered>
      <div className="d-flex align-items-center sl-first-div">
        <span
          tabIndex="0"
          aria-label="close"
          role="button"
          className="d-flex align-items-center"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              props.onHide();
            }
          }}
        >
          <HighlightOffRounded
            style={{ fontSize: '28px' }}
            className="close_circle_icon_sl"
            onClick={() => {
              props.onHide();
            }}
          />
        </span>

        <span className="ls-title" tabIndex="0">
          Select Language
        </span>
      </div>
      <div className="d-flex flex-column align-items-center">
        {lan.map((e, i) => {
          return (
            <div
              tabIndex="0"
              key={e.code}
              className={
                language === e.code
                  ? 'sl-active d-flex align-items-center'
                  : 'sl-normal d-flex align-items-center'
              }
              style={{
                width: '100%',
                height: '55px',
                paddingLeft: '135px',
                paddingTop: '10px',
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  onClick(e);
                }
              }}
              onClick={() => {
                onClick(e);
              }}
            >
              <input
                aria-hidden="true"
                type="radio"
                className="lan-radio"
                id={e.code}
                name={e.name}
                value={e.code}
                onChange={() => {}}
                checked={language === e.code}
                // onChange={onSubmit}
              />
              <label
                for={e.code}
                class="customRadioButton"
                style={{
                  marginRight: '10px',
                }}
              />
              <span className="lan-title">{e.code?.toUpperCase()}</span>
              {/* <Circle className='circle_icon'/>
                    <span className="lan-title">{e.name}</span> */}
            </div>
          );
        })}
      </div>
    </Modal>
  );
}
